// Data
import { arcParticipant }           from "../data/ARC.participant";
import { arcRegisterButtons }       from '../data/ARC.register-buttons';
import { arcPremiumFinance }        from "../data/ARC.premium-finance";
import { arcPaymentInformation }    from "../data/ARC.payment-information";
import { arcReceipt }               from "../data/ARC.receipt";
import { appliedPayActiveRules }    from "./ARC.applied-pay-rules";

export function umbrellaNeuberApplicationForm(store: any): any {
    const { baseUrl, programTitle, effectiveDates, carrier, policyUrl, faqUrl, supportEmail, feeDisclaimer, displayHowMuchInsurance,
        EL_Included, EL_Items, EL_Disclaimers, UM_Label, UM_Items, UM_Disclaimers, EPLI_Items, EPLI_Disclaimer, requiredLimits, CI_Items, learnMoreUrl } = store;

    const umbrellaRules = {
        // Root
        showLandingPage: {
            section: {
                compare: ["#participantToken", "!!"],
                equal: "payment",
                fallback: "register"
            },
            "backToLanding.visible": { compare: ["#applicationName", "!=", "umbrella"] },
            "addressLine1.label": { equal: "Home Address" },
            "addressLine2.label": { equal: "Home Address 2" },
            "email.className": { equal: "col-md-6" },
            "phone.className": { equal: "col-md-6" },
            "fax.visible": { compare: ["#applicationName", "!=", "umbrella"] },
            "suffix.visible": { equal: true },
            "firstName.className": { equal: "col-md-3" },
            "middleName.className": { equal: "col-md-3" },
            "lastName.className": { equal: "col-md-3" }
        },
        section: {
            "header.visible": { compare: ["#section", "==", "register"] },
            "registerForm.visible": { compare: ["#section", "==", "register"] },
            "paymentForm.visible": { compare: ["#section", "==", "payment"] },
            "receipt.visible": { compare: ["#section", "==", "receipt"] }
        },
        showAdditionalInformation: {
            "policyNumber.visible": { compare: ["#showAdditionalInformation", "==", true] },
            "policyExpirationDate.visible": { compare: ["#showAdditionalInformation", "==", true] },
            "coverageInformation.visible": { compare: ["#showAdditionalInformation", "!=", true] }
        },
        // Payment
        isReferral: {
            //"premiumInformation.visible": { compare: ["#isReferral", "!=", true] },
            "referralInformation.visible": { compare: ["#isReferral", "==", true] },
            "paymentInformation.visible": { compare: ["#isReferral", "!=", true] }
        },
        allowCreditCard: {
            "creditcard.visible": { compare: ["#allowCreditCard", "!!"] }
        },
        allowAch: {
            "ach.visible": { compare: ["#allowAch", "!!"] }
        },
        allowPremiumFinance: {
            "premiumFinance.visible": { compare: ["#allowPremiumFinance", "!!"] }
        },
        paymentType: {
            "creditCardPayment.visible": { compare: ["#paymentType.value", "==", "creditcard"] },
            "achPayment.visible": { compare: ["#paymentType.value", "==", "ach"] },
            "premiumFinanceContainer.visible": { compare: ["#paymentType.value", "==", "premiumFinance"] },
            "premiumFinanceSection": { compare: ["#paymentType.value", "==", "premiumFinance"], equal: "request" }
        },
        premiumFinanceType: {
            "socialSecurityNumber.visible": { compare: ["#premiumFinanceType.value", "==", "socialSecurity"] },
            "feinNumber.visible": { compare: ["#premiumFinanceType.value", "==", "fein"] },
            "dateOfBirth.visible": { compare: ["#premiumFinanceType.value", "!!"] }
        },
        premiumFinanceSection: {
            "premiumFinanceRequest.visible": { compare: ["#premiumFinanceSection", "==", "request"] },
            "premiumFinanceQuote.visible": {
                any: [
                    { compare: ["#premiumFinanceSection", "==", "terms"] },
                    { compare: ["#premiumFinanceSection", "==", "payment"] }
                ]
            },
            "premiumFinanceTerms.visible": { compare: ["#premiumFinanceSection", "==", "terms"] },
            "premiumFinancePaymentType.visible": { compare: ["#premiumFinanceSection", "==", "payment"] },
            "paymentInformation.visible": {
                any: [
                    { compare: ["#premiumFinanceSection", "!"] },
                    { compare: ["#premiumFinanceSection", "==", "payment"] }
                ]
            },
            "paymentTypeContainer.visible": { compare: ["#premiumFinanceSection", "!=", "payment"] }
        },
        premiumFinancePaymentType: {
            "creditCardPayment.visible": { compare: ["#premiumFinancePaymentType.value", "==", "pfCreditCard"] },
            "achPayment.visible": { compare: ["#premiumFinancePaymentType.value", "==", "pfAch"] }
        },
        creditCardPayment: {
            "paymentFirstName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] },
            "paymentLastName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] }
        },
        achPayment: {
            "paymentFirstName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] },
            "paymentLastName.visible": { any: [{ compare: ["#achPayment.visible", "!!"] }, { compare: ["#creditCardPayment.visible", "!!"] }] }
        },
        appliedPayActive: appliedPayActiveRules
    };

    // Complimentary Insurance Review displayed if limit >= 10M.
    var CI_Dependencies = EL_Items.slice(1, EL_Items.length).filter(arr => parseInt(arr[1].replace(/[$,*]/g, "")) >= 10000000);

    CI_Dependencies.forEach(arr => {
        var id = arr[0];
        if (!umbrellaRules[id]) umbrellaRules[id] = {};
        umbrellaRules[id][`container${CI_Items[0]}.visible`] = { any: CI_Dependencies.map(arr2 => ({ compare: [`#${arr2[0]}.valid`, "==", true] })) };
    });

    return {
        type: "none",
        itemId: "applicationFormItem",
        className: "main umbrella",
        rules: umbrellaRules,
        items: [
            {
                type: "none",
                className: "global-header arc-content",
                label: `<header>
                    <a class='logo-link' href='${baseUrl}'>
                        <img class='large-logo' src='/assets/images/umbrella/crystal-logo-90.png'>
                        <img class='medium-logo' src='/assets/images/umbrella/crystal-logo-70.png'>
                        <img class='small-logo' src='/assets/images/umbrella/crystal-logo.png'>
                    </a>
                    <div>
                        <div>${programTitle} Group Personal Excess Liability Enrollment</div>
                        <div>Coverage Effective ${effectiveDates} with ${carrier[0]}</div>
                    </div>
                </header>`
            },
            {
                type: "none",
                itemId: "header",
                className: "container arc-content",
                label: `<div class='heading-text'>
                    Please complete the enrollment form by providing the following information.
                    For a copy of ${carrier[1]}'s group excess liability policy, please click <a href='${policyUrl}' target='_blank'>here</a>.
                    You can also access our FAQ document for more information <a href='${faqUrl}' target='_blank'>here</a>.
                    For any additional questions, please <a href='mailto:${supportEmail}' target='_blank'>contact us</a>.
                </div>`
            },
            {
                type: "form",
                itemId: "registerForm",
                items: [
                    arcParticipant,
                    {
                        type: "none",
                        itemId: "coverageInformation",
                        items: [
                            (displayHowMuchInsurance ? {
                                type: "none",
                                itemId: "howMuchInsurance",
                                label: `<section><div class='container'>
                                    <h2>How Much Insurance Is Right For You?</h2>
                                    <div class='margin-bottom-20'><strong>
                                        <div>This tool evaluates your exposure to suggest the correct liability range for your protection.</div>
                                        <div>A completed quiz is not required for enrollment.</div>
                                    </strong></div>
                                    <div>
                                        Anyone can be sued for alleged negligent actions, valid or not.
                                        In general, the wealthier the person responsible, the greater the damages sought by the injured party.
                                        Test your exposure through our proprietary liability assessment tool.
                                    </div>
                                    <div class='button-center margin-top-40'><a href='https://alliantprivateclient.com/whats-my-liability/' target='_blank'><div class='button'>Take The Quiz</div></a></div>
                                </div></section>
                                <div class='container margin-bottom-n55'><h2>Coverage Information</h2></div>
                                ${feeDisclaimer ? `<div class='container font-size-09em margin-bottom-16'>${feeDisclaimer}</div>` : ""}`
                            } : {
                                type: "none",
                                label: `<div class='container margin-bottom-n55'><h2>Coverage Information</h2></div>
                                ${feeDisclaimer ? `<div class='container font-size-09em margin-bottom-16'>${feeDisclaimer}</div>` : ""}`
                            }),
                            {
                                type: "none",
                                itemId: `container${EL_Items[0]}`,
                                className: "required",
                                required: true,
                                rules: {
                                    [EL_Items[0]]: {
                                        [`container${EL_Items[0]}.valid`]: { compare: [`#${EL_Items[0]}.value`, "!!"] }
                                    }
                                },
                                items: [
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<span class='sub-header'>Excess Liability Coverage Options</span>
                                            <a href='javascript:void(0)' class='question-mark'>?</a>
                                            <div class='umbrella-tooltip align'>
                                                Personal excess liability coverage provides you with additional liability protection over and above your primary Homeowners, Automobile, Recreational Vehicle, Watercraft and other personal liability insurance.
                                                It helps protect you from costly personal liability lawsuits that might otherwise put your property and assets at risk.
                                            </div>`
                                    },
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: "<div>Please select your desired coverage limits for each section below.</div>"
                                    },
                                    {
                                        type: "table",
                                        itemId: EL_Items[0],
                                        className: "table table-center container required big-table font-09em",
                                        label: `<th style='width:15%;'><span>Select</span> <span>Level</span></th>
                                                <th style='width:60%;'><span>Liability</span> <span>Limit</span></th>
                                                <th style='width:25%;'><span>Annual</span> <span>Premium</span></th>`,
                                        required: true,
                                        items: [{
                                            type: "row",
                                            label: `<td colspan='3'><strong>All levels include ${EL_Included} Uninsured/Underinsured Motorist Limit & EPLI coverage.</strong></td>`
                                        }].concat(EL_Items.slice(1, EL_Items.length).map(e => ({
                                            type: "row",
                                            itemId: e[0],
                                            parentItemId: EL_Items[0],
                                            className: "cursor-pointer",
                                            label: `<td><input type='radio' id='i${e[0]}' name='${EL_Items[0]}'></td><td>${e[1]}</td><td>${e[2]}</td><td>${e[3]}</td>`,
                                            rules: {
                                                [EL_Items[0]]: {
                                                    [`${e[0]}.valid`]: { compare: [`#${EL_Items[0]}.value`, "==", e[0]] },
                                                    [`${e[0]}.label`]: {
                                                        compare: [`#${EL_Items[0]}.value`, "==", e[0]],
                                                        equal: `<td><input type='radio' id='i${e[0]}' name='${EL_Items[0]}' checked></td><td>${e[1]}</td><td>${e[2]}</td>`,
                                                        fallback: `<td><input type='radio' id='i${e[0]}' name='${EL_Items[0]}'></td><td>${e[1]}</td><td>${e[2]}</td>`
                                                    }
                                                }
                                            }
                                        })))
                                    },
                                    (EL_Disclaimers.length ? {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<div>${EL_Disclaimers.reduce((str, e) => str + `<div class='font-size-09em'>${e}</div>`, "")}</div>`
                                    } : { type: "none" })
                                ]
                            },
                            {
                                type: "none",
                                itemId: `container${UM_Items[0]}`,
                                className: "required",
                                required: true,
                                rules: {
                                    [UM_Items[0]]: {
                                        [`container${UM_Items[0]}.valid`]: { compare: [`#${UM_Items[0]}.value`, "!!"] }
                                    }
                                },
                                items: [
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<span class='sub-header'>Optional Uninsured/Underinsured Motorist Coverage</span>
                                            <a href='javascript:void(0)' class='question-mark'>?</a>
                                            <div class='umbrella-tooltip align'>
                                                Excess Uninsured/Underinsured Motorists (UM/UIM) coverage provides an additional layer of protection over the primary limit on your automobile policy.
                                                This coverage protects you in the event of an accident where the at-fault party is either uninsured or underinsured or flees the scene of an accident.
                                            </div>`
                                    },
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: UM_Label
                                    },
                                    {
                                        type: "table",
                                        itemId: UM_Items[0],
                                        className: "table table-center container required font-09em",
                                        label: `<th style='width:15%;'><span>Select</span> <span>Level</span></th>
                                                <th style='width:60%;'><span>Uninsured/Underinsured</span> <span>Motorist Limit${UM_Disclaimers.length ? "*" : ""}</span></th >
                                                <th style='width:25%;'><span>Additional</span> <span>Premium</span></th>`,
                                        required: true,
                                        items: UM_Items.slice(1,UM_Items.length).map(e => ({
                                            type: "row",
                                            itemId: e[0],
                                            parentItemId: UM_Items[0],
                                            className: "cursor-pointer",
                                            label: `<td><input type='radio' id='i${e[0]}' name='${UM_Items[0]}'></td><td>${e[1]}</td><td>${e[2]}</td>`,
                                            rules: {
                                                [UM_Items[0]]: {
                                                    [`${e[0]}.valid`]: { compare: [`#${UM_Items[0]}.value`, "==", e[0]] },
                                                    [`${e[0]}.label`]: {
                                                        compare: [`#${UM_Items[0]}.value`, "==", e[0]],
                                                        equal: `<td><input type='radio' id='i${e[0]}' name='${UM_Items[0]}' checked></td><td>${e[1]}</td><td>${e[2]}</td>`,
                                                        fallback: `<td><input type='radio' id='i${e[0]}' name='${UM_Items[0]}'></td><td>${e[1]}</td><td>${e[2]}</td>`
                                                    }
                                                }
                                            }
                                        }))
                                    },
                                    (UM_Disclaimers.length ? {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<div>${UM_Disclaimers.reduce((str, e) => str + `<div class='font-size-09em'>${e}</div>`, "")}</div>`
                                    } : { type: "none" })
                                ]
                            },
                            (EPLI_Items.length ? {
                                type: "none",
                                itemId: `container${EPLI_Items[0]}`,
                                className: "required",
                                required: true,
                                rules: {
                                    [EPLI_Items[0]]: {
                                        [`container${EPLI_Items[0]}.valid`]: { compare: [`#${EPLI_Items[0]}.value`, "!!"] }
                                    }
                                },
                                items: [
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<span class='sub-header'>Employment Practices Liability Insurance (EPLI)</span>
                                            <a href='javascript:void(0)' class='question-mark'>?</a>
                                            <div class='umbrella-tooltip align'>
                                                Employment Practices Liability Insurance protects you in the event your domestic employee sues you for alleged wrongful termination, discrimination or sexual harassment.
                                            </div>`
                                    },
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: "Employment Practices Liability Insurance (EPLI) for up to twelve (12) domestic employees."
                                    },
                                    {
                                        type: "table",
                                        itemId: EPLI_Items[0],
                                        className: "table table-center container required font-09em epli-table",
                                        label: `<th><span>Select</span> <span>Level</span></th>
                                                <th><span>Coverage</span> <span>Amount</span></th>
                                                <th>Deductible</th>
                                                <th><span>Additional</span> <span>Premium</span></th>`,
                                        required: true,
                                        items: EPLI_Items.slice(1, EPLI_Items.length).map(e => ({
                                            type: "row",
                                            itemId: e[0],
                                            parentItemId: EPLI_Items[0],
                                            className: "cursor-pointer",
                                            label: `<td><input type='radio' id='i${e[0]}' name='${EPLI_Items[0]}'></td><td${!e[2] ? " colspan='3' class='text-align-left'" : ""}>${e[1]}</td>${e[2] ? `<td>${e[2]}</td>` : ""}${e[3] ? `<td>${e[3]}</td>` : ""}`,
                                            rules: {
                                                [EPLI_Items[0]]: {
                                                    [`${e[0]}.valid`]: { compare: [`#${EPLI_Items[0]}.value`, "==", e[0]] },
                                                    [`${e[0]}.label`]: {
                                                        compare: [`#${EPLI_Items[0]}.value`, "==", e[0]],
                                                        equal: `<td><input type='radio' id='i${e[0]}' name='${EPLI_Items[0]}' checked></td><td class='text-align-left' ${!e[2] ? "colspan='3'" : ""}>${e[1]}</td>${e[2] ? `<td>${e[2]}</td>` : ""}${e[3] ? `<td>${e[3]}</td>` : ""}`,
                                                        fallback: `<td><input type='radio' id='i${e[0]}' name='${EPLI_Items[0]}'></td><td class='text-align-left' ${!e[2] ? " colspan='3'" : ""}>${e[1]}</td>${e[2] ? `<td>${e[2]}</td>` : ""}${e[3] ? `<td>${e[3]}</td>` : ""}`
                                                    }
                                                }
                                            }
                                        }))
                                    },
                                    (EPLI_Disclaimer ? {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<div class='font-size-09em'>${EPLI_Disclaimer}</div>`
                                    } : { type: "none" })
                                ]
                            } : { type: "none" }),
                            {
                                type: "none",
                                itemId: "requiredLimits",
                                label: `<section id='requiredlimits'><div class='container'>
                                    <h2>Required Primary Underlying Liability Limits</h2>
                                    <div class='margin-bottom-20'>
                                        The insurance carriers require the following underlying limits for the primary personal insurance policies.
                                        Failure to maintain these limits will result in a coverage gap.
                                        The minimum underlying limits required by the underwriters are listed below:
                                    </div>
                                    <div class='table-container font-size-09em'>
                                        <table class='table-left table-fixed'>
                                            <colgroup>
                                                <col span='1' class='width-40pct'>
                                                <col span='1' class='width-60pct'>
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>Coverage</th>
                                                    <th>Underlying Limits</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                ${requiredLimits.reduce((str, e) => str + `<tr><td>${e[0]}</td><td>${e[1]}</td>`, "")}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class='font-size-09em'><strong>*</strong>  Coverage is excluded for watercraft longer than 70 feet or with a top speed of more than 65 mph.</div>
                                </div></section>`
                            },
                            {
                                type: "none",
                                itemId: `container${CI_Items[0]}`,
                                visible: !!CI_Dependencies.length,
                                rules: {
                                    [CI_Items[0]]: {
                                        [`container${CI_Items[0]}.valid`]: { compare: [`#${CI_Items[0]}.value`, "!!"] }
                                    }
                                },
                                items: [
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: "<h2>Complimentary Insurance Review</h2>"
                                    },
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<div class='margin-bottom-20'>
                                            Understanding how excess liability fits into your insurance program can help you make sure you're fully addressing all areas of risk, and maintaining the underlying liability requirements of this policy.
                                            As a participant of this program, Alliant Private Client offers to conduct a complimentary, no obligation review of your personal insurance program.
                                        </div>`
                                    },
                                    {
                                        type: "table",
                                        itemId: CI_Items[0],
                                        className: "table table-center container required",
                                        label: "<th class='text-align-center w-100px'>Select Level</th><th class='text-align-left'>Review Options</th>",
                                        required: true,
                                        items: [
                                            {
                                                type: "row",
                                                itemId: CI_Items[1],
                                                parentItemId: CI_Items[0],
                                                className: "cursor-pointer",
                                                label: `<td><input type='radio' id='i${CI_Items[1]}' name='${CI_Items[0]}'></td><td class='text-left'>YES, I would like to have the private client team review my personal insurance program.</td>`,
                                                rules: {
                                                    [CI_Items[0]]: {
                                                        [`${CI_Items[1]}.valid`]: { compare: [`#${CI_Items[0]}.value`, "==", CI_Items[1]] },
                                                        [`${CI_Items[1]}.label`]: {
                                                            compare: [`#${CI_Items[0]}.value`, "==", CI_Items[1]],
                                                            equal: `<td><input type='radio' id='i${CI_Items[1]}' name='${CI_Items[0]}' checked></td><td class='text-left'>YES, I would like to have the private client team review my personal insurance program.</td>`,
                                                            fallback: `<td><input type='radio' id='i${CI_Items[1]}' name='${CI_Items[0]}'></td><td class='text-left'>YES, I would like to have the private client team review my personal insurance program.</td>`
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                type: "row",
                                                itemId: CI_Items[2],
                                                className: "cursor-pointer",
                                                label: `<td><input type='radio' id='${CI_Items[2]}' name='${CI_Items[0]}'></td><td class='text-left'>NO, I do not want a review of my personal insurance program at this time. I'm aware of the underlying limits required by this policy.</td>`,
                                                rules: {
                                                    [CI_Items[0]]: {
                                                        [`${CI_Items[2]}.valid`]: { compare: [`#${CI_Items[0]}.value`, "==", CI_Items[2]] },
                                                        [`${CI_Items[2]}.label`]: {
                                                            compare: [`#${CI_Items[0]}.value`, "==", CI_Items[2]],
                                                            equal: `<td><input type='radio' id='${CI_Items[2]}' name='${CI_Items[0]}' checked></td><td class='text-left'>NO, I do not want a review of my personal insurance program at this time. I'm aware of the underlying limits required by this policy.</td>`,
                                                            fallback: `<td><input type='radio' id='${CI_Items[2]}' name='${CI_Items[0]}'></td><td class='text-left'>NO, I do not want a review of my personal insurance program at this time. I'm aware of the underlying limits required by this policy.</td>`
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        type: "none",
                                        className: "container arc-content",
                                        label: `<div class='button-center margin-top-30'>
                                            <a href='${learnMoreUrl}' target='_blank'><div class='button'>Learn More</div></a>
                                        </div>`
                                    }
                                ]
                            }
                        ]
                    },
                    arcRegisterButtons
                ]
            },
            {
                type: "form",
                itemId: "paymentForm",
                items: [
                    {
                        type: "none",
                        itemId: "referralInformation",
                        className: "container",
                        label: "<strong>Your application for coverage has been referred to Alliant Insurance Services for review.</strong>" +
                            `<a href='${baseUrl}'>New Application</a>`
                    },
                    arcPremiumFinance,
                    arcPaymentInformation
                ]
            },
            arcReceipt,
            {
                type: "none",
                className: "global-footer arc-content",
                label: `<footer>
                    <a href='https://alliantprivateclient.com' target='_blank'>alliantprivateclient.com</a>
                    <div class='container'><span>© 2025 Alliant Insurance Services, Inc.</span> <span>All rights reserved. CA License No. OC36861</span></div>
                </footer>`
            }
        ]
    };
}
